// ----------------------------------------------------------------------

export function createClasses(className: string): string {
  return `${'mona'}__${className}`
}
